import type { Paywall } from '~/interfaces/paywall';
import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import PremiumGatedContent from '../post/PremiumGatedContent';
import PageWrapper from './PageWrapper';

interface Props {
  publication: Publication;
  subscription?: Subscription;
  paywall: Paywall;
}

const GatedPage = ({ publication, subscription, paywall }: Props) => {
  return (
    <PageWrapper>
      <div className="mt-8">
        <PremiumGatedContent paywall={paywall} subscription={subscription} publication={publication} />
      </div>
    </PageWrapper>
  );
};

export default GatedPage;
